import React from "react";
import { Link, LinkProps } from "@mui/material";

type CustomLinkProps = LinkProps & {
    label: string;
    type?: string;
};

export default function CustomLink(props: CustomLinkProps) {
    return (
        <Link
            component="button"
            {...props}
            sx={{
                color: "#005499",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                borderBottom: "1px solid  #005499",
                textDecoration: "none",
                ...props?.sx,
            }}
        >
            {props.label}
        </Link>
    );
}
